import { render, staticRenderFns } from "./BuyedProject.vue?vue&type=template&id=753e25be&"
import script from "./BuyedProject.vue?vue&type=script&lang=js&"
export * from "./BuyedProject.vue?vue&type=script&lang=js&"
import style0 from "./BuyedProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports